<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="625px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Confira os documentos!
    </h3>
    <p class="c-ndarkfour text-center">
        Antes de prosseguir, confira se <span class="bold">anexou todos os documentos<br>
        devidamente preenchida e assinada:</span>
    </p>
    <DocumentsChecklist isModal :complementaryRegister="complementaryRegister" class="col-12 px-0 mx-0 d-flex justify-content-center mt-4"/>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Cancelar
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="confirm">
            Ok, continuar
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
import DocumentsChecklist from '@/components/register/DocumentsChecklist'

export default {
    components: {
      AlertExclamationRegister,
      DocumentsChecklist
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        complementaryRegister: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        confirm() {
            this.$emit('confirm')
        }
    },
}
</script>

<style>
</style>